import Rest from "../../../class/tool/Rest";
import Store from "./Store";
import Contact from "../Contacts/Contact";
import Countries from "../../../class/tool/Countries";
import FormBuilder from "../../../class/tool/FormBuilder";
import StringTools from "../../../class/tool/StringTools";
import AuthController from "../../_auth/Auth/AuthController";
import RegexTools from "../../../class/tool/RegexTools";
import StoreHistory from "../StoreHistories/StoreHistory";
import AddressController from "../Addresses/AddressController";
import StoreRequest from "./StoreRequest";

class StoreController {
    _rest = new Rest();
    _callback = null;
    _baseURL = "stores";
    _baseURLHistory = "stores/:idStore/history";
    _errors = {
        "partnership_id": {
            "empty": "Vous devez sélectionner un partenaire"
        },
        "request_id": {
			"wrong": "L'ID de la requête est erroné"
        },
		"creator_id": {
			"empty": "Vous devez sélectionner l'utilisateur qui créer le client"
		},
        "company_id": {
            "wrong": "Le groupe que vous tentez d'affilier n'est pas valide"
        },
        "company_name": {
            "empty": "Le nom du groupe est obligatoire",
            "wrong": "Le nom doit être compris entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
        },
        "name": {
            "empty": "Le nom du client est obligatoire",
            "wrong": "Le nom doit être compris entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
        },
        "socialReason": {
            "wrong": "La raison sociale doit être comprise entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
        },
        "sector": {
            "wrong": "Vous devez sélectionner un secteur d'activité"
        },
        "assigned_to_id": {
            "empty": "Vous devez sélectionner un utilisateur",
            "wrong": "L'utilisateur choisi est incorrecte"
        },
        "assigned_to_type": {
            "empty": "Vous devez sélectionner un type d'utilisateur"
        },
		"siren": {
			"empty": "Vous devez saisir le SIREN ou le SIRET",
			"wrong": "Le SIREN ou le SIRET est incorrect"
		},
		"postalCode": {
			"empty": "Le code postal est obligatoire",
			"wrong": "Le code postal est invalide"
		},
		"city": {
			"empty": "La ville est obligatoire",
			"wrong": "La ville est invalide, catactères autorisés : - '"
		},
		"country": {
			"empty": "Le pays est obligatoire",
			"wrong": "Le pays est invalide"
		},
		"email": {
			"wrong": "L'addresse email est invalide"
		},
		"phone": {
			"wrong": "Le numéro de fixe est invalide"
		},
		"manager": {
			"empty": "Le nom du gérant est obligatoire",
			"wrong": "Le nom doit être compris entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
		}
    };
    _sectors = [
        {
            value: "Choisir le secteur d'activité",
            id: null
        },
        {
            value: "----------",
            id: null
        },
        {
            value: "Boulangerie",
            id: 1
        },
        {
            value: "Coiffeur / Institue de beauté",
            id: 2
        },
        {
            value: "Commerce de détail",
            id: 3
        },
        {
            value: "Prêt à porter",
            id: 4
        },
        {
            value: "Restauration assise",
            id: 5
        },
        {
            value: "Bar",
            id: 6
        },
        {
            value: "Snacking / V.A.E",
            id: 7
        }
    ];
    static _states = {
        "ACTIVE": "Actif",
        "STANDBY": "Inactif",
        "EJECT": "Supprimé"
    };

    // perform

    setFormValues(object, setValues, formNew = false, datas) {
        const user = JSON.parse(localStorage.getItem("user"));

        if (formNew) {
			if (datas.request !== undefined && datas.request !== null) {
				object.request_id = datas.request.id;
				object.partnership_id = datas.request.partnership_id;
				object.name = datas.request.name;
				object.sector = datas.request.sector;
			}

            setValues(prev => ({
                ...prev,
                partnership_id: (datas.request !== undefined && datas.request !== null) ? object.partnership_id : (!AuthController.hasRules(["admin"]) ? user.partnership.id : datas.partnerships[0].id),
                company_id: object.company_id,
                company_name: object.company_name,
                name: object.name,
				sector: object.sector,
				request_id: object.request_id !== undefined ? object.request_id : null
            }));
        }
        else {
            setValues(prev => ({
                ...prev,
                company_name: object.company_name,
                name: object.name,
				sector: object.sector
            }));
        }
    }
	setFormRequestValues(object, setValues, formNew = false, datas) {
		const user = JSON.parse(localStorage.getItem("user"));

		if (formNew) {
			setValues(prev => ({
				...prev,
				creator_id: object.creator_id !== null ? object.creator_id : user.id,
				partnership_id: user.partnership.id,
				company_id: object.company_id,
				company_name: object.company_name,
				name: object.name,
				siren: object.siren,
				postalCode: object.postalCode,
				city: object.city,
				country: "FRANCE",
				sector: object.sector,
				phone: object.phone,
				email: object.email,
				manager: object.manager
			}));
		}
	}
    setFormAssignUserValues(object, setValues) {
        setValues(prev => ({
            ...prev,
            assigned_to_id: object.assigned_to_id,
            assigned_to_type: "USER"
        }));
    }
    setFormRows(setRows, formNew = false, datas) {
        let rows;

        if (formNew) {
            rows = [
                {
                    label: "Nom",
                    attribute: "name",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "Boutique",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "Secteur d'activité",
                    attribute: "sector",
                    inputType: "select",
                    returnType: "string",
                    list: this._sectors,
                    dictionary: null,
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    classnameNoInput: "",
                    needed: true,
                    checkData: null
                },
                {
                    label: "Groupe",
                    attribute: "company_name",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "Nom du groupe",
                    additional: "Nécessaire pour basculer sur un environnement multi-boutique",
                    autoComplete: "off",
                    needed: false,
                    checkData: null
                }
            ]

            if (AuthController.hasRules(["admin"])) {
                rows.splice(0, 0, {
                    label: "Propriétaire",
                    attribute: "partnership_id",
                    inputType: "select",
                    returnType: "int",
                    list: datas.partnerships,
                    dictionary: null,
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    classnameNoInput: "",
                    needed: true,
                    checkData: null
                });
            }
        }
        else {
            if (AuthController.hasRules(["admin"])) {
                rows = [
					{
						label: "Nom",
						attribute: "name",
						inputType: "text",
						returnType: "string",
						classnameWrapper: null,
						classnameLabel: null,
						classnameInput: "",
						placeholder: "Boutique",
						autoComplete: "off",
						needed: true,
						checkData: null
					},
                	{
						label: "Secteur d'activité",
						attribute: "sector",
						inputType: "select",
						returnType: "string",
						list: this._sectors,
						dictionary: null,
						classnameWrapper: null,
						classnameLabel: null,
						classnameInput: "",
						classnameNoInput: "",
						needed: true,
						checkData: null
					}
				];

				if (datas.company_name !== null) {
					rows.splice(0, 0, {
						label: "Groupe",
						attribute: "company_name",
						inputType: "text",
						returnType: "string",
						classnameWrapper: null,
						classnameLabel: null,
						classnameInput: "",
						placeholder: "Nom du groupe",
						autoComplete: "off",
						needed: true,
						checkData: null
					});
				}
            }
        }

        setRows(rows);
    }
	setFormRequestRows(setRows, formNew = false, datas) {
		let rows;

		if (formNew) {
			rows = [
				{
					label: "Nom",
					attribute: "name",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Boutique",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Groupe",
					attribute: "company_name",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Nom du groupe",
					additional: "Nécessaire pour basculer sur un environnement multi-boutique",
					autoComplete: "off",
					needed: false,
					checkData: null
				},
				{
					label: "Gérant",
					attribute: "manager",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "M. Jean-Michel",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "SIREN ou SIRET",
					attribute: "siren",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "123 456 789",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Code postal",
					attribute: "postalCode",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "75000",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Ville",
					attribute: "city",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Paris",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Pays",
					attribute: "country",
					inputType: "select",
					returnType: "string",
					list: AddressController._countries,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Secteur d'activité",
					attribute: "sector",
					inputType: "select",
					returnType: "string",
					list: this._sectors,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Email",
					attribute: "email",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "christine.dupont@mail.com",
					autoComplete: "off",
					needed: false,
					checkData: null
				},
				{
					label: "Téléphone",
					attribute: "phone",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "09",
					autoComplete: "off",
					needed: false,
					checkData: null
				}
			]
		}

		setRows(rows);
	}
    setFormAssignUserRows(setRows, datas) {
        let rows;

        rows = [
            {
                label: "Utilisateur",
                attribute: "assigned_to_id",
                inputType: "select",
                returnType: "int",
                list: datas.users,
                dictionary: null,
                classnameWrapper: null,
                classnameLabel: null,
                classnameInput: "",
                classnameNoInput: "",
                needed: true,
                checkData: null
            }
        ]

        setRows(rows);
    }
    returnPostDatas(datas) {
        let datasToPost = {};
        let needed = ["partnership_id", "name", "sector"];
        let optionals = ["company_id", "company_name", "request_id"];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
	returnPostRequestDatas(datas) {
		let datasToPost = {};
		let needed = ["name", "siren", "postalCode", "city", "country", "sector", "manager"];
		let optionals = ["company_id", "company_name", "phone", "email"];

		for (let i in needed) {
			datasToPost[needed[i]] = datas[needed[i]];
		}

		for (let i in optionals) {
			if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

			switch (typeof datas[optionals[i]]) {
				case "string":
					if (datas[optionals[i]].length === 0) continue;
					break;
				default: break;
			}

			datasToPost[optionals[i]] = datas[optionals[i]];
		}

		return datasToPost;
	}
    returnPostAssignUserDatas(datas) {
        let datasToPost = {};
        let needed = ["assigned_to_id", "assigned_to_type"];
        let optionals = [];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
    returnPutDatas(datas) {
        let datasToPost = {};
        let needed = ["name", "sector"];
        let optionals = ["company_name"];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
    returnUpdatesFromCompare(object, datas, compare = true) {
        return FormBuilder.returnUpdates(object, datas, compare)
    }

    hasValidMinimumDatas(values, type, subType = null) {
        let datas;
        let resultData;

        switch (type) {
            case "client":
				switch (subType) {
					case "request":
						datas = this.returnPostRequestDatas(values);

						for (let key in datas) {
							resultData = this.checkDataToPostRequest(key, datas[key]);

							if (!resultData.result)
								return false;
						}

						return true;
					default:
						datas = this.returnPostDatas(values);

						for (let key in datas) {
							resultData = this.checkDataToPost(key, datas[key]);

							if (!resultData.result)
								return false;
						}

						return true;
				}
			case "request":
            case "assignUser":
                datas = this.returnPostAssignUserDatas(values);

                for (let key in datas) {
                    resultData = this.checkDataToAssignUser(key, datas[key]);

                    if (!resultData.result)
                        return false;
                }

                return true;
			case "updateStore":
                datas = this.returnPutDatas(values);

                for (let key in datas) {
                    resultData = this.checkDataToPut(key, datas[key]);

                    if (!resultData.result)
                        return false;
                }

                return true;
            default:
                return false;
        }
    }
	okToSend(datas, setEvent) {
		return true;
	}
    checkDataToPost(attribute, value) {
        switch (attribute) {
            case "partnership_id": return this.controlPartnershipId(value);
            case "request_id": return this.controlRequestId(value);
            case "company_id": return this.controlCompanyId(value);
            case "company_name": return this.controlCompanyName(value);
            case "name": return this.controlName(value);
            case "socialReason": return this.controlSocialReason(value);
            case "sector": return this.controlSector(value);
            default:
                console.log("Unknown attribute", attribute);

                return {
                    result: false,
                    error: "Unknown attribute"
                };
        }
    }
	checkDataToPostRequest(attribute, value) {
		switch (attribute) {
			case "partnership_id": return this.controlPartnershipId(value);
			case "creator_id": return this.controlCreatorId(value);
			case "company_id": return this.controlCompanyId(value);
			case "company_name": return this.controlCompanyName(value);
			case "name": return this.controlName(value);
			case "siren": return this.controlSiren(value);
			case "postalCode": return this.controlPostalCode(value);
			case "city": return this.controlCity(value);
			case "country": return this.controlCountry(value);
			case "sector": return this.controlSector(value);
			case "phone": return this.controlPhone(value);
			case "email": return this.controlEmail(value);
			case "manager": return this.controlManager(value);
			default:
				console.log("Unknown attribute", attribute);
				return {
					result: false,
					error: "Unknown attribute"
				};
		}
	}
    checkDataToAssignUser(attribute, value) {
        switch (attribute) {
            case "assigned_to_id": return this.controlAssignToId(value);
            case "assigned_to_type": return this.controlAssignToType(value);
            default:
                console.log("Unknown attribute", attribute);
                return {
                    result: false,
                    error: "Unknown attribute"
                };
        }
    }
    checkDataToPut(attribute, value) {
        switch (attribute) {
            case "company_name": return this.controlCompanyNameNeeded(value);
            case "name": return this.controlName(value);
            case "sector": return this.controlSector(value);
            default:
                console.log("Unknown attribute", attribute);

                return {
                    result: false,
                    error: "Unknown attribute"
                };
        }
    }
    controlPartnershipId(value) {
        let regex = RegexTools.getRegex("id");

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["partnership_id"]["empty"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
	controlRequestId(value) {
		let regex = /^[0-9]{1,}$/;

		if (!regex.test(value)) {
			return {
				result: false,
				error: this._errors["request_id"]["wrong"]
			};
		}

		return {
			result: true,
			error: null
		};
	}
    controlCreatorId(value) {
        let regex = /^[0-9]{1,}$/;

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["creator_id"]["empty"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlCompanyId(value) {
        if (value !== null) {
            let regex = /^[0-9]{1,}$/;

            if (!regex.test(value)) {
                return {
                    result: false,
                    error: this._errors["company_id"]["empty"]
                };
            }
        }

        return {
            result: true,
            error: null
        };
    }
    controlCompanyName(value) {
        if (value.length === 0)
            return null;

        let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

        if (!regex.test(StringTools.removeAccents(value))) {
            return {
                result: false,
                error: this._errors["company_name"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlCompanyNameNeeded(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["company_name"]["empty"]
            };
        }

        let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

        if (!regex.test(StringTools.removeAccents(value))) {
            return {
                result: false,
                error: this._errors["company_name"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlName(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["name"]["empty"]
            };
        }

        let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

        if (!regex.test(StringTools.removeAccents(value))) {
            return {
                result: false,
                error: this._errors["name"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlSocialReason(value) {
        if (value.length === 0)
            return null;

        let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

        if (!regex.test(StringTools.removeAccents(value))) {
            return {
                result: false,
                error: this._errors["socialReason"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlSector(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["sector"]["wrong"]
            };
        }

        let regex = /^[a-zA-Z/.\s]{2,30}$/i;

        if (!regex.test(StringTools.removeAccents(value))) {
            return {
                result: false,
                error: this._errors["sector"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlAssignToId(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["assigned_to_id"]["empty"]
            };
        }

        let regex = /^[0-9]{1,}$/i;

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["assigned_to_id"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlAssignToType(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["assigned_to_type"]["wrong"]
            };
        }

        if (value !== "USER") {
            return {
                result: false,
                error: this._errors["assigned_to_type"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
	controlSiren(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false,
				error: this._errors["name"]["empty"]
			};
		}

		let regex = RegexTools.getRegex("sirenOrSiret");

		if (!regex.test(StringTools.removeAccents(value))) {
			return {
				result: false,
				error: this._errors["siren"]["wrong"]
			};
		}

		return {
			result: true,
			error: null
		};
	}
	controlManager(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false,
				error: this._errors["name"]["empty"]
			};
		}

		let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

		if (!regex.test(StringTools.removeAccents(value))) {
			return {
				result: false,
				error: this._errors["manager"]["wrong"]
			};
		}

		return {
			result: true,
			error: null
		};
	}
	controlEmail(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false,
				error: this._errors["name"]["empty"]
			};
		}

		let regex = RegexTools.getRegex("email");

		if (!regex.test(value)) {
			return {
				result: false,
				error: this._errors["email"]["wrong"]
			};
		}

		return {
			result: true,
			error: null
		};
	}
	controlPhone(value) {
		return {
			result: true,
			error: null
		};
	}
	controlPostalCode(value) {
		if (value !== null && value.length > 0) {
			let regex = RegexTools.getRegex("postalCode");

			if (!regex.test(StringTools.removeAccents(value))) {
				return {
					result: false,
					error: this._errors["postalCode"]["wrong"]
				};
			}
		}
		else {
			return {
				result: false,
				error: this._errors["postalCode"]["empty"]
			};
		}

		return {
			result: true,
			error: null
		};
	}
	controlCity(value) {
		if (value !== null && value.length > 0) {
			let regex = RegexTools.getRegex("city");

			if (!regex.test(StringTools.removeAccents(value))) {
				return {
					result: false,
					error: this._errors["city"]["wrong"]
				};
			}
		}
		else {
			return {
				result: false,
				error: this._errors["city"]["empty"]
			};
		}

		return {
			result: true,
			error: null
		};
	}
	controlCountry(value) {
		if (value !== null && value.length > 0) {
			let regex = RegexTools.getRegex("country");

			if (!regex.test(StringTools.removeAccents(value))) {
				return {
					result: false,
					error: this._errors["country"]["wrong"]
				};
			}
		}
		else {
			return {
				result: false,
				error: this._errors["country"]["empty"]
			};
		}

		return {
			result: true,
			error: null
		};
	}

    // Controllers

    index(type, state, version, input, page, perPage, sortingName, sortingValue) {
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + "?type=" + type + "&state=" + state + "&version=" + version + "&page=" + page + "&perPage=" + perPage + "&sortingName=" + sortingName + "&sortingValue=" + sortingValue + (input !== "" ? "&input=" + input : ""),
            {},
            this.handleIndex)
    }
    handleIndex = (response, error, status) => {
        let listObjects = []
        let pagination = null

        if(status === 200) {
            let data

            if (response.data !== undefined && response.data.data !== undefined) {
                if(response.data.total !== undefined) {
                    pagination = {
                        total: response.data.total,
                        from: response.data.from != null ? response.data.from : 0,
                        to: response.data.to != null ? response.data.to : 0,
                        per_page: response.data.per_page,
                        current_page: response.data.current_page,
                        first_page_url: new URL(response.data.first_page_url).search,
                        last_page_url: new URL(response.data.last_page_url).search,
                        next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
                        prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
                    }
                }

                data = response.data.data
            }
            else if (response.data)
                data = response.data

            for(let item in data)
                listObjects.push(new Store(data[item]))
        }

        this._callback(listObjects, error, pagination, status)
    }

    show(id) {
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/' + id,
            {},
            this.handleShow)
    }
    handleShow = (response, error, status) => {
        const object = !error ? new Store(response.data) : null
        this._callback(object, error, status)
    }

    post(datas) {
        this._rest.sendQuery(
            'POST',
            '/' + this._baseURL,
            datas,
            this.handlePost
        )
    }
    handlePost = (response, error, status) => {
        if (this._callback !== null) {
            this._callback(response, error, status)
        }
    }

	listRequests() {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + '/requests',
			{},
			this.handleListRequests
		)
	}
	handleListRequests = (response, error, status) => {
		let listObjects = []
		let pagination = null

		if(status === 200) {
			let data

			if (response.data !== undefined && response.data.data !== undefined) {
				if(response.data.total !== undefined) {
					pagination = {
						total: response.data.total,
						from: response.data.from != null ? response.data.from : 0,
						to: response.data.to != null ? response.data.to : 0,
						per_page: response.data.per_page,
						current_page: response.data.current_page,
						first_page_url: new URL(response.data.first_page_url).search,
						last_page_url: new URL(response.data.last_page_url).search,
						next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
						prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
					}
				}

				data = response.data.data
			}
			else if (response.data)
				data = response.data

			for(let item in data)
				listObjects.push(new StoreRequest(data[item]))
		}

		this._callback(listObjects, error, pagination, status)
	}

	request(datasToStringify) {
		this._rest.sendQuery(
			'POST',
			'/' + this._baseURL + '/request',
			{
				datas: JSON.stringify(datasToStringify)
			},
			this.handleRequest
		)
	}
	handleRequest = (response, error, status) => {
		if (this._callback !== null) {
			this._callback(response, error, status)
		}
	}

	getRequest(id) {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + '/request/' + id,
			{},
			this.handleGetRequest
		)
	}
	handleGetRequest = (response, error, status) => {
		const object = !error ? new StoreRequest(response.data) : null;
		this._callback(object, error, status);
	}

	requestExecuted(id) {
		this._rest.sendQuery(
			'PATCH',
			'/' + this._baseURL + '/request/' + id,
			{},
			this.handleRequestExecuted
		)
	}
	handleRequestExecuted = (response, error, status) => {
		if (this._callback !== null) {
			this._callback(response, error, status)
		}
	}

	requestRemoved(id) {
		this._rest.sendQuery(
			'DELETE',
			'/' + this._baseURL + '/request/' + id,
			{},
			this.handleRequestRemoved
		)
	}
	handleRequestRemoved = (response, error, status) => {
		if (this._callback !== null) {
			this._callback(response, error, status)
		}
	}

    put(object, datas) {
        this._rest.sendQuery(
            'PUT',
            '/' + this._baseURL + '/' + object.id,
            datas,
            this.handlePut
        )
    }
    handlePut = (response, error, status) => {
        this._callback(response, error, status)
    }

    delete(object) {
        this._rest.sendQuery(
            'DELETE',
            '/' + this._baseURL + '/' + object.id,
            {},
            this.handleDelete)
    }
    handleDelete = (response, error, status) => {
        this._callback(response, error, status)
    }

    toClient(object) {
        this._rest.sendQuery(
            'POST',
            '/' + this._baseURL + '/' + object.id + '/toclient',
            {},
            this.handleToClient
        )
    }
    handleToClient = (response, error, status) => {
        this._callback(response, error, status)
    }

	getLastCreated(nb) {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + "/lastcreated?nb=" + nb,
			{},
			this.handleGetLastCreated)
	}
	handleGetLastCreated = (response, error, status) => {
		let listObjects = [];

		if(status === 200) {
			let data = response.data;

			for(let item in data)
				listObjects.push(new Store(data[item]));
		}

		this._callback(listObjects, error, status);
	}

	getLastViewed(nb) {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + "/lastviewed?nb=" + nb,
			{},
			this.handleGetLastViewed)
	}
	handleGetLastViewed = (response, error, status) => {
		let listObjects = [];

		if(status === 200) {
			let data = response.data;

			for(let item in data)
				listObjects.push(new StoreHistory(data[item]));
		}

		this._callback(listObjects, error, status);
	}

	fragmentation() {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + "/fragmentation",
			{},
			this.handleFragmentation);
	}
	handleFragmentation = (response, error, status) => {
		this._callback(response, error, status);
	}

	fragmentationList() {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + "/fragmentationList",
			{},
			this.handleFragmentationList);
	}
	handleFragmentationList = (response, error, status) => {
		this._callback(response, error, status);
	}

    // Contacts

    indexContact(store, input= "") {
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/' + store.id + '/contacts' + (input !== "" ? "?input=" + input : ""),
            {},
            this.handleIndexContact)
    }
    handleIndexContact = (response, error, status) => {
        let listObjects = []

        if(response.data !== undefined) {
            const data = response.data.contacts

            for(var item in data)
                listObjects.push( new Contact(data[item]))
        }

        this._callback(listObjects, error, status)
    }

    // History

    postHistory(store, datas) {
		datas.hidden = false;

        this._rest.sendQuery(
            'POST',
            '/' + this._baseURLHistory.replace(":idStore", store.id),
            datas,
            this.handlePostHistory
        )
    }
    handlePostHistory = (response, error, status) => {
        if (this._callback !== null) {
            this._callback(response, error, status)
        }
    }

    deleteHistory(history) {
        this._rest.sendQuery(
            'DELETE',
            '/' + this._baseURLHistory.replace(":idStore", history.store_id) + '/' + history.id,
            {},
            this.handleDeleteHistory
        )
    }
    handleDeleteHistory = (response, error, status) => {
        if (this._callback !== null) {
            this._callback(response, error, status)
        }
    }
}

export default StoreController;
